let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ewJpS")).then(() => parcelRequire('89hBd'));